import NextLink, { LinkProps } from 'next/link';
import { FC } from 'react';

export const Link: FC<LinkProps> = (props) => {
  return <NextLink {...props} scroll={false} legacyBehavior />;
};
